export const getCategoryLabel = (label) => label && label.replace("-", " ");

export const getAcronym = (label) =>
  label &&
  label
    .split(/[-\ ]+/)
    .map((w) => w[0])
    .join("")
    .toLowerCase();
